/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 4/7/2023
 */
import BaseObject from "@shared/BaseObject.js";
import dayjs from "dayjs";

export default class WatchChannel extends BaseObject {

	id: string = null
	resourceId: string = null
	expiresAt: number = null
	syncToken: string = null
	renewTaskId: string = null

	constructor(id: string, resourceId: string) {
		super();
		this.id = id;
		this.resourceId = resourceId;
	}

	isExpiringSoon(){
		let daysBeforeExpire = dayjs(this.expiresAt).diff(dayjs(), "day")
		return daysBeforeExpire < 1
	}
}
